import React, {memo, useState} from "react";
import Container from "@mui/material/Container";
import {Box} from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import BasicProfile from "../../components/Profile/basic";

import {Paper} from "@mui/material";
import UniqueProfile from "../../components/Profile/uniq";
import BankProfile from "../../components/Profile/bank";
import PasswordProfile from "../../components/Profile/password";
import {Head} from "../../components";
import AncestryChange from "../../components/Profile/ancestry";
import DocumentProfile from "../../components/Profile/myDocument";
import MarketerRevoke from "../../components/Profile/revoke";
import MarketerAddress from "../../components/Profile/address";
import {useParams} from "react-router-dom";

const actions = [
    { name: 'اطلاعات اولیه', 'step' : 0 },
    { name: 'اطلاعات کاربری', 'step' : 1 },
    { name: 'اطلاعات بانکی', 'step' : 2 },
    { name: 'تغییر رمز', 'step' : 3 },
    { name: 'تایید مدارک', 'step' : 4 },
    { name: 'جا به جایی', 'step' : 5 },
    { name: 'تعلیق جایگاه و بازگشت', 'step' : 6 },
];

const MarketerProfile = memo((props) => {


    const { id } = useParams();
    

    const [step, setStep] = useState(0);

    const switchStep = () => {
        switch (step) {
            case 0:
                return (<BasicProfile id={id} />);
                break;
            case 1:
                return (<UniqueProfile id={id} />);
                break;
            case 2:
                return (<BankProfile id={id} />);
                break;
            case 3:
                return (<PasswordProfile id={id} />);
                break;
            case 4:
                return (<DocumentProfile id={id} />);
                break;
            case 5:
                return (<AncestryChange id={id} />);
                break;
            case 6:
                return (<MarketerRevoke id={id} />);
                break;
            case 7:
                return (<MarketerAddress id={id} />);
                break;
        }
    };


    const handleChangeTab = (event, newValue) => {
        setStep(newValue);
    };

    return(
        <div style={{ padding: '0 20px'}}>
            <Head data={{ 'link': '/marketer', 'title': 'ویرایش اطلاعات', 'description': 'اطلاعات بازاریاب را ویرایش کنید' }} />
            <Box>
                <Paper elevation={0}>
                    <Tabs
                        value={step}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        {actions.map((item) => {
                            return(
                                <Tab label={item.name} />
                            );
                        })}

                    </Tabs>
                </Paper>

                {switchStep()}
            </Box>
        </div>
    );
})

export default MarketerProfile;